import { EditScanPage } from '@/pages/facility/edit-scan';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/edit-scan/$scanId')({
	component: EditScanPage,
});
